var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 360,
    viewBox: "0 0 480 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Name=Formulario Empresa, Shape=-"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 85"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.892 357.194C191.381 353.829 150.545 342.404 121.168 312.853C91.8576 283.37 81.3823 242.436 77.6248 201.012C73.3721 154.129 69.8655 103.901 98.8517 66.8308C130.607 26.2195 181.565 6.88548 232.892 2.44207C289.547 -2.46254 358.573 -4.39963 392.31 41.426C425.196 86.0958 384.393 145.777 379.08 201.012C374.688 246.674 395.639 299.09 364.306 332.565C332.629 366.408 279.07 360.938 232.892 357.194Z",
    fill: "url(#paint0_linear_2274_99518)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter0_dd_2274_99518)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.637 29C347.225 29 412 127.809 412 230.387C412 307.073 321.836 331 246.637 331C166.942 331 68 311.658 68 230.387C68 124.337 142.645 29 246.637 29Z",
    fill: "url(#paint1_linear_2274_99518)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "remix-icons/outlined/buildings/building-2-line",
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M181.586 226.667V138C181.585 136.631 181.997 135.296 182.766 134.175C183.534 133.054 184.622 132.201 185.882 131.733L249.025 108.293C249.518 108.11 250.047 108.051 250.568 108.121C251.088 108.191 251.584 108.388 252.014 108.695C252.444 109.003 252.795 109.412 253.037 109.887C253.28 110.363 253.406 110.891 253.406 111.427V144.447L294.644 158.48C295.945 158.922 297.076 159.771 297.877 160.907C298.679 162.042 299.11 163.407 299.11 164.807V226.667H312.168V240H168.527V226.667H181.586ZM194.644 226.667H240.348V125.7L194.644 142.673V226.667ZM286.052 226.667V169.613L253.406 158.5V226.667H286.052Z",
    fill: "#41435B"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2274_99518",
    x: 60,
    y: 25,
    width: 360,
    height: 318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2274_99518"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2274_99518",
    result: "effect2_dropShadow_2274_99518"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2274_99518",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2274_99518",
    x1: 405,
    y1: 180,
    x2: 74.7932,
    y2: 180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13729,
    stopColor: "#5A46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866499,
    stopColor: "#1E95FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2274_99518",
    x1: 68,
    y1: 180,
    x2: 412,
    y2: 180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB432"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCompany);
export default __webpack_public_path__ + "static/media/createCompany.2ca39e102aeeaae21bc7c9b2bcf63e4c.svg";
export { ForwardRef as ReactComponent };